import { useState, useMemo } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { PlusIcon, XIcon } from '@heroicons/react/solid';
import { TrashIcon } from '@heroicons/react/outline';
import useSubjects from '../../hooks/useSubjects';
import {
  postSubject as postSubjectService,
  deleteSubject as deleteSubjectService,
} from '../../redux/services/subjectService';

const Subjects = () => {
  const subjectQuery = useSubjects();
  const [isAdding, setIsAdding] = useState<Boolean>(false);
  const [newSubject, setNewSubject] = useState<string>('');

  const addSubject = async () => {
    await postSubjectService(newSubject);
    setNewSubject('');
    setIsAdding(false);
    subjectQuery.refetch();
  };

  const deleteSubject = async (id: string) => {
    await deleteSubjectService(id);
    subjectQuery.refetch();
  };

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'label',
        headerName: 'Onderwerp',
        flex: 1,
        headerClassName: 'bg-gray-100',
      },
      {
        field: 'action',
        headerName: '',
        flex: 0.1,
        headerClassName: 'bg-gray-100',
        renderCell: (params) => {
          return (
            <button
              title="Delete"
              className="w-full flex justify-center"
              onClick={(e) => {
                e.stopPropagation();
                deleteSubject(params.row._id);
              }}
            >
              <TrashIcon className="w-5 text-gray-500 hover:text-gray-700" />
            </button>
          );
        },
      },
    ];
  }, []);

  if (!subjectQuery.isSuccess) {
    return <p>Loading...</p>;
  }

  return (
    <div className="flex-col space-y-3">
      {!subjectQuery.data.length && <p>Nog geen onderwerpen</p>}
      <DataGrid
        autoHeight
        rows={subjectQuery.data}
        columns={columns}
        getRowId={(row) => row._id}
        className="bg-white"
      />
      {isAdding ? (
        <div className="flex space-x-3">
          <input
            title="Subject"
            type={'text'}
            className="rounded-md"
            onChange={(e) => setNewSubject(e.target.value)}
          />
          <button
            className="flex text-white rounded-md p-2 bg-sky hover:bg-sky-dark space-x-1"
            onClick={() => {
              setIsAdding(false);
              setNewSubject('');
            }}
          >
            <XIcon className="w-5" />
            <p>Cancel</p>
          </button>
          <button
            className="flex text-white rounded-md p-2 bg-sky hover:bg-sky-dark space-x-1"
            onClick={addSubject}
            disabled={!newSubject.length}
          >
            <PlusIcon className="w-5" />
            <p>Toevoegen</p>
          </button>
        </div>
      ) : (
        <button
          className="flex text-white rounded-md p-2 bg-sky hover:bg-sky-dark space-x-1"
          onClick={() => setIsAdding(true)}
        >
          <PlusIcon className="w-5" />
          <p>Nieuw onderwerp</p>
        </button>
      )}
    </div>
  );
};

export default Subjects;
